module.exports = __webpack_public_path__ + "static/media/img-09.c5d6bb1e.jpg";